<template>
    <BasePaymentRadioInput
        :selected-payment-method="selectedPaymentMethod"
        :numeric-value="3"
        name="simplepay"
        :title-text="$t('form.online-payment-method.title')"
        :subtitle-text="$t('form.online-payment-method.subtitle')"
        :update-value="(value) => $emit('update-payment-method', value)"
        :logo="{
            url: 'https://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf',
            img: require('~/assets/images/logos/simplepay.png'),
            alt: 'SimplePay',
        }"
    />
</template>

<script>
import BasePaymentRadioInput from './BasePaymentRadioInput.vue';

export default {
    name: 'SimplePayRadioInput',
    components: {
        BasePaymentRadioInput,
    },
    props: {
        selectedPaymentMethod: {
            type: Number,
            required: false,
            default: null,
        },
    },
};
</script>

<style scoped></style>
